export enum DateType {
  CREATE = "Created Date",
  CLOSE = "Closed Date",
}

export enum DateRange {
  TODAY = "Today",
  YESTERDAY = "Yesterday",
  THIS_WEEK = "This week (Sun - today)",
  LAST_WEEK = "Last week (Sun - Sat)",
  LAST_7_DAYS = "Last 7 days",
  LAST_28_DAYS = "Last 28 days",
  LAST_30_DAYS = "Last 30 days",
  LAST_90_DAYS = "Last 90 days",
  LAST_180_DAYS = "Last 180 days",
  LAST_365_DAYS = "Last 365 days",
  THIS_MONTH = "This month (month to date)",
  LAST_MONTH = "Last month",
  THIS_QUARTER = "This calendar quarter (quarter to date)",
  LAST_QUARTER = "Last calendar quarter",
  THIS_YEAR = "This calendar year (year to date)",
  LAST_YEAR = "Last calendar year",
  ALL_TIME = "All time",
  CUSTOM = "Custom",
}

export enum RecordType {
  CONTACTS = "Contacts",
  DEALS = "Deals",
}
